import { FC } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { Colors } from '../controls/helpers';

const Grid: FC<{ className?: string; classes?: Record<string, any>; }> = (props) => {
    const { children, className } = props;
    const classes = useStyles(props);
    return <Box className={clsx(classes.root, className)}>{children}</Box>
}

export default Grid;

interface RowProps {
    className?: string;
    classes?: Record<string, any>;
}

const Row: FC<RowProps> = (props) => {
    const { children, className } = props;
    const classes = useStyles(props);
    return <Box className={classes.row}>
        <Box className={clsx(className, classes.rowContent)}>{children}</Box>
    </Box>
}

export const Banner: FC<RowProps> = (props) => {
    const classes = useStyles(props);
    return <Row classes={{ row: classes.spacer }} {...props} />
}

export const Header: FC<RowProps> = (props) => {
    const classes = useStyles(props);
    return <Row classes={{ row: classes.header }} {...props} />
}

export const Body: FC<RowProps> = (props) => {
    const classes = useStyles(props);
    return <Row classes={{ row: classes.body }} {...props} />
}

const useStyles = makeStyles(() => ({
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    row: {
        display: 'flex',
        justifyContent: 'center',
        paddingLeft: 20,
        paddingRight: 20,
        '@media(min-width: 768px)': {
            '&:last-child': {
                flex: '1 0 auto'
            }
        }
    },
    rowContent: {
        width: '100%',
        '@media(min-width: 768px)': {
            width: 1500
        }
    },
    spacer: {
        backgroundColor: Colors.MediumGrey
    },
    header: {
        backgroundColor: Colors.MediumGrey,
        '& $rowContent': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: Colors.LightGrey,
            padding: 0
        }
    },
    body: {
        backgroundColor: Colors.MediumGrey,
        flex: '1 0 auto',
        '@media(min-width: 768px)': {
            flex: 0
        },
        '& $rowContent': {
            backgroundColor: Colors.White,
            padding: 12,
            display: 'flex',
            flexDirection: 'column',
            '@media(min-width: 768px)': {
                minHeight: 312,
                padding: '18px 24px'
            },
            '& h4': {
                marginBottom: 60
            }
        }
    }
}), { name: 'AdviserGrid' });
